import { createFileRoute } from "@tanstack/react-router";
import LensesPage from "src/components/app/LensesPage/LensesPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getLensesPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/lenses/")({
  loader: projectLoader((projectId) => getLensesPageData({ data: projectId })),
  component: PortalLensesPage,
});

function PortalLensesPage() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <LensesPage projectId={data?.projectId} initialLenses={data?.initialLenses} />}
    </DeferredLoaderData>
  );
}
